import React, { useEffect, useState } from "react";
import "../css/Home.css";
import "../css/Unsubscribe.css";
import { Helmet } from "react-helmet";

function Unsubscribe() {
    const [status, setStatus] = useState("loading");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const email = params.get("email");

        if (!email) {
            setStatus("error");
            return;
        }

        // Call backend API endpoint to unsubscribe
        fetch(`https://cdyuxireni.execute-api.us-east-2.amazonaws.com/unsubscribe?email=${encodeURIComponent(email)}`)
            .then((res) => (res.ok ? setStatus("done") : setStatus("error")))
            .catch(() => setStatus("error"));
    }, []);

    return (
        <div className="page unsubscribe-page">
            <Helmet>
                <title>Unsubscribe - Thenics4All</title>
            </Helmet>

            {status === "loading" && <h2>Processing your request...</h2>}

            {status === "done" && (
                <>
                    <h2>You’re unsubscribed 💬</h2>
                    <p style={{ maxWidth: 420, margin: "10px auto", color: "#555" }}>
                        You won’t receive weekly Thenics4All updates anymore.
                    </p>
                    <p>
                        Changed your mind?{" "}
                        <a href="/settings" style={{ color: "#daa520" }}>
                            Re-enable updates in your profile settings
                        </a>
                    </p>
                </>
            )}

            {status === "error" && (
                <>
                    <h2>Something went wrong 😕</h2>
                    <p>Please try again later.</p>
                </>
            )}
        </div>
    );
}

export default Unsubscribe;
